import { graphql } from 'src/graphql';

export const SessionPages = graphql(`
  query CalendarSessionPages($bookingId: ID!) {
    bookingByID(id: $bookingId) {
      _id
      config {
        session_pages {
          before {
            url
            title
            description
          }
          after {
            url
            title
            description
          }
        }
      }
      session {
        _id
        session_pages {
          before {
            url
            title
            description
          }
          after {
            url
            title
            description
          }
        }
      }
    }
  }
`);
